<div class="settings-management-header settings-header-license"
     translate="MODAL.INFO">
</div>

<div class="pop-display-flex">
  <div class="firstColumn">
    <p-message *ngFor="let msg of messages"
               severity="{{ msg.severity }}"
               text="{{ msg.detail }}"
               styleClass="p-mr-2">
    </p-message>
    <div class="settings-option-box license-detail-box">
      <div class="container">
        <div class="input-group">
          <span class="settings-label"
                translate="OPTIONS.COMPANY"></span>
          <input disabled
                 value="{{ verifiedLicense?.companyName }}" />
        </div>

        <div *ngFor="let module of verifiedLicense?.modules">
          <p class="license-module-title">
            <span translate="OPTIONS.MODULE"></span>: {{ module.name }}
            <span *ngIf="module.demo">({{ "OPTIONS.DEMO" | translate }})</span>
          </p>
          <div class="module-detail-container">
            <div class="input-group">
              <span class="settings-label"
                    translate="OPTIONS.NUMBER_OF_LICENSED_USERS"></span>
              <input disabled
                     value="{{ module.number }}" />
            </div>
            <div class="input-group">
              <span class="settings-label"
                    translate="OPTIONS.EXPIRATION"></span>
              <input disabled
                     value="{{ module.expiration | dateFormat: 'yyyy-MM-dd' }}" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="settings-description"
       translate="OPTIONS.LICENSE_DESC">
  </div>
</div>

<!-- New licence-->
<label for="license-file"
       class="license-upload-btn">
  <i class="far fa-upload"></i>
  {{ "OPTIONS.LICENSE_UPLOAD" | translate }}
</label>
<div class="license-file-box"
     *ngIf="license">
  <i class="far fa-times"
     (click)="cancelLicense()"></i>
  <span class="license-name">{{ this.license?.name }}</span>
</div>
<ng-container *ngIf="!license">
  <input name="license-file"
         id="license-file"
         class="license-input"
         type="file"
         (change)="uploadLicense($event)"
         accept=".xml" />
</ng-container>
<!-- New licence-->

<pop-license-user-table *ngIf="verifiedLicense"
                        [verifiedLicense]="verifiedLicense"
                        (showError)="showError($event)"></pop-license-user-table>
